import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getListStylePositionOptions,
  getListStyleTypeOptions,
} from "@circle-react-shared/BuilderUI/utils/listStyleTextHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ul",
  props: {
    items: {
      prop: "other",
      type: "list",
      value: [
        {
          id: uuidv4(),
          value: "Item 1",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
        {
          id: uuidv4(),
          value: "Item 2",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
        {
          id: uuidv4(),
          value: "Item 3",
          bullet: {
            emoji: "",
            signed_id: "",
            placeholder: "",
          },
        },
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(defaultStyles.color),
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        listStyleType: getListStyleTypeOptions(defaultStyles.listStyleType),
        listStylePosition: getListStylePositionOptions(
          defaultStyles.listStylePosition,
        ),
      },
    },
  },
};
